// src/pages/Recommendations.tsx
import React, { useState } from 'react';
import './Recommendations.css';
import { FaQuoteLeft, FaQuoteRight, FaStar } from 'react-icons/fa';

const Recommendations: React.FC = () => {
  const [expandedCard, setExpandedCard] = useState<number | null>(null);

  const toggleExpand = (index: number) => {
    if (expandedCard === index) {
      setExpandedCard(null);
    } else {
      setExpandedCard(index);
    }
  };

  const recommendations = [
    {
      name: "Andrew Nolff",
      role: "Founder, M8 Social Platform",
      initials: "AN",
      rating: 5,
      shortQuote: "Mantavya's technical leadership transformed our vision into a scalable platform that exceeded our expectations.",
      fullQuote: "As the founder of M8, I had the pleasure of working directly with Mantavya during our platform development. His technical leadership was exceptional in turning our vision into reality. Mantavya architected a scalable backend using Node.js/Express with MongoDB that now supports over 5,000 users. His React and Redux expertise delivered a responsive user experience with consistently positive feedback. Most impressive was his ability to lead our development team while establishing effective CI/CD processes. His combination of technical excellence, leadership, and collaborative spirit made him invaluable to our success.",
      date: "April 2025"
    },
    {
      name: "Dr. Eva Steiner",
      role: "Professor, Real Estate Finance, Penn State University",
      initials: "ES",
      rating: 5,
      shortQuote: "Mantavya's research contributions demonstrated exceptional technical skill and analytical thinking.",
      fullQuote: "I had the privilege of mentoring Mantavya during his research work at Penn State. His contributions to our real estate finance data analysis project were outstanding. Mantavya developed a sophisticated algorithm that significantly improved our model's predictive accuracy for market trend forecasting. What sets him apart is his combination of technical prowess and business acumen - he consistently considered real-world applications of our research. His work ethic, intellectual curiosity, and collaborative approach make him an exceptional candidate for any organization.",
      date: "March 2025"
    },
    {
      name: "Professor Arvind Rangaswamy",
      role: "Distinguished Professor of Marketing, Penn State University",
      initials: "AR",
      rating: 5,
      shortQuote: "Mantavya's innovative approach to our research challenges demonstrated exceptional technical and analytical capabilities.",
      fullQuote: "As Mantavya's research advisor, I was consistently impressed by his exceptional work in marketing analytics projects. He developed a novel recommendation system using BERT4Rec and sentence transformers that significantly outperformed traditional models. His LLM-based product ideation algorithm demonstrated both technical mastery and creative problem-solving. Mantavya's ability to bridge cutting-edge AI techniques with practical business applications is rare and valuable. His contributions have been published in our research journal and continue to influence our ongoing work.",
      date: "February 2025"
    },
    {
      name: "[Alchem Contact]",
      role: "Senior Developer, Alchem International",
      initials: "AC",
      rating: 5,
      shortQuote: "During his time at Alchem, Mantavya demonstrated exceptional technical skills and problem-solving abilities.",
      fullQuote: "Mantavya worked with our development team at Alchem International, where he made significant contributions to our web applications. His technical expertise, dedication to quality, and collaborative approach made him a valuable team member. He consistently delivered high-quality code and worked effectively with cross-functional teams. His work on optimizing database queries and implementing new features directly contributed to improved performance and user satisfaction.",
      date: "August 2024"
    }
  ];

  return (
    <div className="netflix-recommendations-container">
      {/* Banner section */}
      <div className="recommendations-banner">
        <div className="banner-content">
          <h1 className="netflix-title">PROFESSIONAL ENDORSEMENTS</h1>
          
          <div className="netflix-meta">
            <span className="match">98% Match</span>
            <span className="year">2025</span>
            <span className="rating">REC</span>
            <span className="duration">Industry Validated</span>
          </div>

          <p className="banner-description">
            Discover what colleagues and mentors have to say about my technical skills, 
            collaborative approach, and professional contributions. These endorsements 
            reflect my commitment to excellence across various roles and projects.
          </p>
        </div>
      </div>

      {/* Recommendations Section */}
      <section className="recommendations-section">
        <h2 className="netflix-category-title">Featured Recommendations</h2>
        
        <div className="recommendations-grid">
          {recommendations.map((recommendation, index) => (
            <div 
              key={index} 
              className={`recommendation-card ${expandedCard === index ? 'expanded' : ''}`}
              onClick={() => toggleExpand(index)}
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="recommendation-header">
                <div className="recommender-profile">
                  <div className="recommender-avatar">
                    {recommendation.initials}
                  </div>
                  <div className="recommender-info">
                    <h3 className="recommender-name">{recommendation.name}</h3>
                    <p className="recommender-role">{recommendation.role}</p>
                    <div className="recommendation-rating">
                      {[...Array(5)].map((_, i) => (
                        <FaStar 
                          key={i} 
                          className={i < recommendation.rating ? 'star filled' : 'star empty'} 
                        />
                      ))}
                    </div>
                    <span className="recommendation-date">{recommendation.date}</span>
                  </div>
                </div>
              </div>
              
              <div className="recommendation-content">
                <FaQuoteLeft className="quote-icon left" />
                <p className="recommendation-text">
                  {expandedCard === index ? recommendation.fullQuote : recommendation.shortQuote}
                </p>
                <FaQuoteRight className="quote-icon right" />
              </div>
              
              <div className="recommendation-footer">
                <button className="view-toggle">
                  {expandedCard === index ? 'Show Less' : 'Read More'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Recommendations;